{
  "admin-sus-users.chart-failed": "无法加载图表:",
  "admin-sus-users.deselect": "不选择",
  "admin-sus-users.filter-label": "按名称/IP筛选 (回车确认):",
  "admin-sus-users.loading": "加载中...",
  "admin-sus-users.mask-label": "掩码 (仅IPv4):",
  "admin-sus-users.select": "选择",
  "admin-sus-users.unknown-error": "未知错误",
  "articles.authorship.author-label": "作者:",
  "articles.authorship.clear": "清除",
  "articles.authorship.close": "关闭",
  "articles.authorship.disown-cancel": "取消",
  "articles.authorship.disown-confirm": "是，我要放弃",
  "articles.authorship.disown-note": "请注意，只有该页面作者栏中指定的人或管理员才能将作者权归还给您",
  "articles.authorship.disown-title": "是否放弃页面作者身份?",
  "articles.authorship.error-dismiss": "关闭",
  "articles.authorship.error-label": "错误：",
  "articles.authorship.needs-one-author": "必须至少指定一个作者",
  "articles.authorship.save": "保存",
  "articles.authorship.saved": "保存成功！",
  "articles.authorship.saving": "保存中...",
  "articles.authorship.title": "页面作者信息",
  "articles.backlinks.children-heading": "子页面",
  "articles.backlinks.close": "关闭",
  "articles.backlinks.empty": "此页面没有反向链接",
  "articles.backlinks.error-dismiss": "关闭",
  "articles.backlinks.error-label": "错误:",
  "articles.backlinks.includes-heading": "嵌入 (使用 [[include]])",
  "articles.backlinks.links-heading": "反向链接",
  "articles.backlinks.title": "依赖此页面的其他页面",
  "articles.child.cancel": "关闭",
  "articles.child.child-name-label": "子页面名称:",
  "articles.child.close": "关闭",
  "articles.child.create": "创建",
  "articles.child.error-dismiss": "关闭",
  "articles.child.error-label": "错误:",
  "articles.child.hint-label": "提示:",
  "articles.child.invalid-name": "无效的子页面ID!",
  "articles.child.note": "此操作将创建一个以此页面为父页面的新页面",
  "articles.child.parent-name-label": "此页面名称:",
  "articles.child.title": "创建子页面",
  "articles.delete.already-deleted": "此页面已被标记为删除，无法再次删除",
  "articles.delete.cancel": "取消",
  "articles.delete.close": "关闭",
  "articles.delete.close-blocked": "关闭",
  "articles.delete.confirm": "删除",
  "articles.delete.confirm-cancel": "取消",
  "articles.delete.confirm-permanent": "此操作将永久删除页面且无法恢复。确定要继续吗？",
  "articles.delete.deleted": "删除成功!",
  "articles.delete.deleting": "删除中...",
  "articles.delete.error-dismiss": "关闭",
  "articles.delete.error-label": "错误:",
  "articles.delete.how-label": "如何操作?",
  "articles.delete.move": "移动至分类 \"deleted\"",
  "articles.delete.note": "您可以将页面移至“deleted”分类，或永久删除（此操作不可恢复，请谨慎操作）。",
  "articles.delete.note-no-permanent": "您可以将页面移至“deleted”分类以完成删除。永久删除功能不可用。",
  "articles.delete.option-permanent": "永久删除",
  "articles.delete.option-rename": "重命名",
  "articles.delete.option-unavailable": " (不可用)",
  "articles.delete.rename-note": "为页面添加前缀“deleted:”可将其移至其他分类（命名空间）。此操作相当于删除，但信息不会丢失。",
  "articles.delete.title": "删除页面",
  "articles.delete.title-blocked": "删除页面",
  "articles.delete.warning-already-deleted": "该页面已在“deleted”分类中。如需永久删除，请使用“永久删除”。",
  "articles.delete.warning-label": "注意:",
  "articles.diff.close": "关闭",
  "articles.diff.created-label": "创建于:",
  "articles.diff.error-dismiss": "关闭",
  "articles.diff.error-label": "错误:",
  "articles.diff.revision-label": "版本",
  "articles.diff.source-heading": "更改源代码:",
  "articles.diff.title": "比较页面版本",
  "articles.editor.cancel": "取消",
  "articles.editor.comment-label": "更改摘要:",
  "articles.editor.error-dismiss": "关闭",
  "articles.editor.error-label": "错误:",
  "articles.editor.loading": "加载中，请稍候...",
  "articles.editor.page-title-label": "页面标题:",
  "articles.editor.preview": "预览",
  "articles.editor.save": "保存",
  "articles.editor.saved": "保存成功!",
  "articles.editor.saving": "保存中...",
  "articles.editor.title-edit": "编辑页面",
  "articles.editor.title-new": "创建页面",
  "articles.favourite.close": "关闭",
  "articles.favourite.count": "{count} 人收藏",
  "articles.favourite.dismiss": "关闭",
  "articles.favourite.error-label": "错误：",
  "articles.favourite.failed": "操作失败，请稍后重试",
  "articles.favourite.private": "收藏是私密的。没有人能看到谁收藏了这个页面，作者也不能。",
  "articles.favourite.title": "收藏这个页面",
  "articles.favourite.toggle": "收藏 / 取消收藏",
  "articles.files.close": "关闭",
  "articles.files.column-name": "文件名",
  "articles.files.column-size": "大小",
  "articles.files.column-type": "文件类型",
  "articles.files.count-label": "文件数量:",
  "articles.files.current-name-label": "当前名称:",
  "articles.files.delete": "删除",
  "articles.files.delete-failed": "删除文件失败",
  "articles.files.drop-hint": "点击上传文件，或拖拽文件至此处",
  "articles.files.error-dismiss": "关闭",
  "articles.files.error-label": "错误:",
  "articles.files.new-name-label": "新名称:",
  "articles.files.not-uploaded-label": "文件未上传:",
  "articles.files.options": "选项",
  "articles.files.rename": "重命名",
  "articles.files.rename-cancel": "取消",
  "articles.files.rename-confirm": "重命名",
  "articles.files.rename-failed": "重命名文件失败",
  "articles.files.rename-title": "重命名",
  "articles.files.site-usage-label": "站点已使用空间:",
  "articles.files.size-bytes": "{size} 字节",
  "articles.files.title": "文件",
  "articles.files.total-size-label": "总大小:",
  "articles.files.upload": "上传",
  "articles.files.upload-all": "上传全部",
  "articles.files.upload-failed": "文件上传失败",
  "articles.footnote.heading": "脚注 {number}.",
  "articles.footnote.hint": "（点击查看脚注）",
  "articles.history.authors-added": "已添加作者: {added}.",
  "articles.history.authors-added-removed": "已添加作者: {added}. 已移除作者: {removed}.",
  "articles.history.authors-removed": "已移除作者: {removed}.",
  "articles.history.close": "关闭",
  "articles.history.column-actions": "操作",
  "articles.history.column-author": "由",
  "articles.history.column-comment": "评论",
  "articles.history.column-date": "日期",
  "articles.history.column-flags": "标记",
  "articles.history.column-revision": "版本",
  "articles.history.compare": "比较版本",
  "articles.history.created": "正在创建新页面",
  "articles.history.date-ago": "{duration}前",
  "articles.history.error-dismiss": "关闭",
  "articles.history.error-label": "错误:",
  "articles.history.file-added": "已上传文件: \"{name}\"",
  "articles.history.file-deleted": "已删除文件: \"{name}\"",
  "articles.history.file-renamed": "文件已重命名: \"{from}\" 至 \"{to}\"",
  "articles.history.flag-file-added": "已上传文件",
  "articles.history.flag-file-deleted": "已删除文件",
  "articles.history.flag-file-renamed": "文件已重命名",
  "articles.history.flag-migrated": "从Wikidot迁移的版本",
  "articles.history.flag-name": "页面已重命名/删除",
  "articles.history.flag-new": "已创建新页面",
  "articles.history.flag-parent": "父页面已更改",
  "articles.history.flag-source": "内容已更改",
  "articles.history.flag-tags": "标签已更改",
  "articles.history.flag-title": "标题已更改",
  "articles.history.flag-votes": "评分已更改",
  "articles.history.name-changed": "页面已从 \"{from}\" 更改为 \"{to}\"",
  "articles.history.parent-changed": "父页面已从 \"{from}\" 更改为 \"{to}\"",
  "articles.history.parent-removed": "已移除父页面 \"{parent}\"",
  "articles.history.parent-set": "已设置父页面 \"{parent}\"",
  "articles.history.refresh": "更新列表",
  "articles.history.revert": "回复至修订版本",
  "articles.history.reverted": "页面已回滚至版本 #{revision}",
  "articles.history.tags-added": "已添加标签: {added}.",
  "articles.history.tags-added-removed": "已添加标签: {added}. 已移除标签: {removed}.",
  "articles.history.tags-removed": "已移除标签: {removed}.",
  "articles.history.title": "页面更改历史",
  "articles.history.title-changed": "标题已从 \"{from}\" 更改为 \"{to}\"",
  "articles.history.view-source": "检视页面源代码",
  "articles.history.view-version": "检视页面版本",
  "articles.history.votes-deleted": "页面评分已重置: {rating} (评分数: {votes}, 人气: {popularity}%)",
  "articles.lightbox.close": "关闭",
  "articles.lightbox.next": "下一张",
  "articles.lightbox.number": "图像 {current} / {total}",
  "articles.lightbox.prev": "上一张",
  "articles.lock.cancel": "关闭",
  "articles.lock.close": "关闭",
  "articles.lock.error-dismiss": "关闭",
  "articles.lock.error-label": "错误:",
  "articles.lock.locked-label": "页面已锁定:",
  "articles.lock.note": "页面被锁定后，只有拥有“锁定文章”权限的用户才能编辑、移动、删除它，或修改它的标签、作者和文件。此功能适用于首页等需要保护的页面。",
  "articles.lock.save": "保存",
  "articles.lock.saved": "保存成功!",
  "articles.lock.saving": "保存中...",
  "articles.lock.title": "锁定此页面",
  "articles.newpage.create-failed": "创建页面时出错",
  "articles.parent.breadcrumb-wiki-label": "面包屑导航",
  "articles.parent.breadcrumb-wiki-url": "https://zh.wikipedia.org/wiki/面包屑导航",
  "articles.parent.cancel": "关闭",
  "articles.parent.clear": "清除",
  "articles.parent.close": "关闭",
  "articles.parent.error-dismiss": "关闭",
  "articles.parent.error-label": "错误:",
  "articles.parent.note": "想要创建清晰的“返回”导航路径或构建站点结构？请为此页面设置父页面（上一级页面）。",
  "articles.parent.note-after-link": "请将输入框留空。",
  "articles.parent.note-before-link": "如果不需要",
  "articles.parent.parent-name-label": "父页面名称:",
  "articles.parent.save": "设置父页面",
  "articles.parent.saved": "保存成功!",
  "articles.parent.saving": "保存中...",
  "articles.parent.title": "父页面与面包屑",
  "articles.rating.cancel-vote": "取消评分",
  "articles.rating.close": "关闭",
  "articles.rating.dislike": "不喜欢",
  "articles.rating.error-dismiss": "关闭",
  "articles.rating.error-label": "错误:",
  "articles.rating.like": "喜欢",
  "articles.rating.migrated": "wikit迁移",
  "articles.rating.other-voters": "其他用户的评分",
  "articles.rating.popularity-title": "人气值（3.0分及以上评分占比）",
  "articles.rating.rate-label": "评价页面:",
  "articles.rating.reset": "重置评分",
  "articles.rating.reset-cancel": "取消",
  "articles.rating.reset-confirm": "是的，我确认重置",
  "articles.rating.reset-note": "请注意，此操作可通过版本历史进行回滚。",
  "articles.rating.reset-title": "重置页面评分?",
  "articles.rating.stars-label": "评分: ",
  "articles.rating.title": "页面评分",
  "articles.rating.updown-label": "评分: ",
  "articles.rating.votes-title": "评分数",
  "articles.rename.cancel": "关闭",
  "articles.rename.close": "关闭",
  "articles.rename.current-name-label": "页面名称:",
  "articles.rename.error-dismiss": "关闭",
  "articles.rename.error-label": "错误:",
  "articles.rename.new-name-label": "新页面名称:",
  "articles.rename.note": "{action} 操作将更改页面的“unix名称”，即页面的访问地址。",
  "articles.rename.note-action": "重命名",
  "articles.rename.saved": "保存成功!",
  "articles.rename.saving": "保存中...",
  "articles.rename.submit": "重命名/移动",
  "articles.rename.title": "重命名/移动页面",
  "articles.source.close": "关闭",
  "articles.source.error-dismiss": "关闭",
  "articles.source.error-label": "错误:",
  "articles.source.title": "页面源代码",
  "articles.tags.cancel": "关闭",
  "articles.tags.clear": "清除",
  "articles.tags.close": "关闭",
  "articles.tags.error-dismiss": "关闭",
  "articles.tags.error-label": "错误:",
  "articles.tags.note": "标签是整理站点内容、在相关页面间建立“横向导航”的有效方式。您可以为每个页面添加多个标签。了解更多关于",
  "articles.tags.note-and": ", 以及",
  "articles.tags.save": "保存标签",
  "articles.tags.saved": "保存成功!",
  "articles.tags.saving": "保存中...",
  "articles.tags.tag-cloud-wiki-label": "标签云",
  "articles.tags.tag-cloud-wiki-url": "http://zh.wikipedia.org/wiki/标签云",
  "articles.tags.tag-wiki-label": "标签",
  "articles.tags.tag-wiki-url": "http://zh.wikipedia.org/wiki/标签_(元数据)",
  "articles.tags.tags-label": "标签:",
  "articles.tags.title": "页面标签",
  "common.server-unreachable": "连接服务器失败",
  "components.authorship-editor.add-label": "添加作者:",
  "components.authorship-editor.search-hint": "（输入以搜索用户）",
  "components.tag-editor.add-label": "添加标签:",
  "components.tag-editor.cannot-create": "本页面仅允许添加已存在的标签",
  "components.tag-editor.create": "新建标签“{tag}”",
  "components.tag-editor.search-hint": "（输入以搜索标签）",
  "favourites.breadcrumb": "收藏",
  "favourites.breadcrumb-profile": "个人",
  "favourites.count": "共 {count} 个页面",
  "favourites.crumb": "收藏",
  "favourites.empty": "你还没有收藏任何页面。",
  "favourites.title": "我的收藏",
  "forum-new-post.title": "新回复",
  "forum-post-options.by": "来自",
  "forum-post-options.delete": "删除",
  "forum-post-options.edit": "编辑",
  "forum-post-options.error-dismiss": "关闭",
  "forum-post-options.error-label": "错误:",
  "forum-post-options.hide": "- 隐藏",
  "forum-post-options.last-edited": "最后编辑于",
  "forum-post-options.options": "选项",
  "forum-post-options.reply": "回复",
  "forum-post-options.revisions-title": "消息版本",
  "forum-post-options.show-more": "显示更多",
  "forum-post-options.show-revisions": "显示编辑记录",
  "forum-thread-options.category-label": "请指定新分类:",
  "forum-thread-options.description-label": "描述:",
  "forum-thread-options.edit-action": "编辑名称和描述",
  "forum-thread-options.edit-cancel": "取消",
  "forum-thread-options.edit-save": "保存",
  "forum-thread-options.edit-title": "编辑主题名称和描述",
  "forum-thread-options.error-dismiss": "关闭",
  "forum-thread-options.error-label": "错误:",
  "forum-thread-options.lock": "锁定",
  "forum-thread-options.move-action": "移动",
  "forum-thread-options.move-cancel": "取消",
  "forum-thread-options.move-save": "保存",
  "forum-thread-options.move-title": "移动主题",
  "forum-thread-options.name-label": "主题标题:",
  "forum-thread-options.pin": "置顶",
  "forum-thread-options.saving": "保存中...",
  "forum-thread-options.unlock": "解除锁定",
  "forum-thread-options.unpin": "取消置顶",
  "forum.likes.close": "关闭",
  "forum.likes.dismiss": "关闭",
  "forum.likes.error-label": "错误：",
  "forum.likes.failed": "操作失败，请稍后重试",
  "forum.likes.next": "下一页",
  "forum.likes.page-of": "第 {page} 页，共 {total} 页",
  "forum.likes.previous": "上一页",
  "forum.likes.title": "{count} 人点赞",
  "forum.likes.toggle": "点赞",
  "forum.likes.who": "查看点赞的人",
  "forum.post-editor.cancel": "取消",
  "forum.post-editor.description-label": "主题简短描述:",
  "forum.post-editor.error-dismiss": "关闭",
  "forum.post-editor.error-label": "错误:",
  "forum.post-editor.loading": "加载中，请稍候...",
  "forum.post-editor.post-title-label": "帖子标题:",
  "forum.post-editor.preview": "预览",
  "forum.post-editor.saved": "保存成功！",
  "forum.post-editor.saving": "保存中...",
  "forum.post-editor.submit": "提交",
  "forum.post-editor.thread-title-label": "主题标题:",
  "forum.post-preview.author-label": "创建者:",
  "forum.post-preview.date-label": "日期:",
  "forum.post-preview.description-label": "描述:",
  "forum.post-preview.preview-label": "预览:",
  "forum.post-preview.reply-label": "回复预览:",
  "messages.breadcrumb": "私信",
  "messages.breadcrumb-profile": "个人",
  "messages.conversation-list.delete-confirm": "确定删除与所选 {count} 位用户的全部私信吗？删除仅对您生效，对方仍可看到这些私信。此操作不可撤销。",
  "messages.conversation-list.delete-confirm-button": "删除",
  "messages.conversation-list.delete-failed": "删除对话失败",
  "messages.conversation-list.delete-selected": "删除所选对话",
  "messages.conversation-list.empty": "暂无会话。前往任意用户资料页可发起私信。",
  "messages.conversation-list.load-failed": "加载会话列表失败",
  "messages.conversation-list.loading": "加载中…",
  "messages.conversation-list.select": "选择",
  "messages.conversation-list.select-all": "全选",
  "messages.conversation-list.select-cancel": "取消",
  "messages.conversation-list.selected-count": "已选 {count} 个对话",
  "messages.conversation-view.cannot-send": "你无法向该用户发送消息",
  "messages.conversation-view.empty": "还没有消息。发送第一条消息开始对话吧。",
  "messages.conversation-view.input-placeholder": "输入消息…（回车发送，Shift+回车换行）",
  "messages.conversation-view.load-failed": "加载会话失败",
  "messages.conversation-view.loading": "加载中…",
  "messages.conversation-view.next": "下一步 →",
  "messages.conversation-view.ok": "好",
  "messages.conversation-view.report": "检举",
  "messages.conversation-view.report-cancel": "取消",
  "messages.conversation-view.report-count": "检举 {count} 条消息",
  "messages.conversation-view.report-failed": "提交失败",
  "messages.conversation-view.report-note": "提交后，选中的消息内容会连同你的理由一起发送给 {site} 的管理员。",
  "messages.conversation-view.report-placeholder": "请说明检举理由（提交给管理员，最多 2000 字）",
  "messages.conversation-view.report-submit": "提交检举",
  "messages.conversation-view.report-submitted": "检举已提交，管理员会尽快处理。",
  "messages.conversation-view.select-all": "全选",
  "messages.conversation-view.select-cancel": "取消",
  "messages.conversation-view.selected-count": "已选 {count} 条",
  "messages.conversation-view.send": "发送",
  "messages.conversation-view.send-failed": "发送失败",
  "messages.conversation-view.sending": "发送中…",
  "messages.conversation-view.unknown-user": "用户 #{id}",
  "messages.conversation-view.with-partner": "与 {partner} 的对话",
  "messages.crumb": "私信",
  "messages.empty": "请选择一个会话查看，或前往任意用户资料页发起私信。",
  "messages.search": "查找",
  "messages.search-placeholder": "输入用户名查找并发信…",
  "messages.searching": "查找中",
  "messages.title": "私信",
  "messages.user-not-found": "未找到该用户",
  "notifications.breadcrumb": "通知",
  "notifications.breadcrumb-profile": "个人",
  "notifications.clear-all": "清空",
  "notifications.clear-all-confirm": "确定清空当前列表中的全部通知吗？此操作不可撤销。",
  "notifications.clear-confirm-button": "清理",
  "notifications.clear-selected": "清理所选",
  "notifications.clear-selected-confirm": "确定清理所选的 {count} 条通知吗？此操作不可撤销。",
  "notifications.crumb": "通知",
  "notifications.infinite-scroll.empty": "暂无通知 :(",
  "notifications.item.comment-label": "评论：",
  "notifications.item.from-author-in": "来自 {author} 在话题中 {section}",
  "notifications.item.from-site": "来自 {site}",
  "notifications.item.liked-by": "{author} 赞了你的帖子",
  "notifications.item.new-membershipapply": "{sender} 提交了入组申请",
  "notifications.item.new-message": "{sender} 给你发了新私信",
  "notifications.item.new-report": "{sender} 检举了 {subject}",
  "notifications.item.new-ticket": "{sender} 提交了支持工单",
  "notifications.item.release-hint": "满足条件后会在更新时段自动安装。超级管理员可在管理后台推迟或跳过。",
  "notifications.item.release-notes": "查看版本说明",
  "notifications.item.render-failed": "通知渲染失败",
  "notifications.item.result-membershipapply": "您的入组申请{status}",
  "notifications.item.result-report": "您对 {subject} 的检举{status}",
  "notifications.item.result-ticket": "您的支持工单{status}",
  "notifications.item.rolled-back-hint": "该版本不会再自动安装。超级管理员可以在管理后台查看失败原因。",
  "notifications.item.type-mention": "在论坛中提到您",
  "notifications.item.type-new-post": "新的论坛消息",
  "notifications.item.type-post-like": "点赞",
  "notifications.item.type-post-reply": "回复了您的消息",
  "notifications.item.type-release": "pwikit {version} 已发布",
  "notifications.item.type-rolled-back": "更新到 pwikit {version} 失败，已回档到 {from}",
  "notifications.item.type-watched-edit": "关注的页面有新的编辑",
  "notifications.item.type-welcome": "欢迎来到本站",
  "notifications.item.view-conversation": "查看会话",
  "notifications.item.view-own-tickets": "查看我提交的工单",
  "notifications.item.view-post": "查看消息",
  "notifications.item.view-ticket": "前往处理",
  "notifications.kind-all": "全部",
  "notifications.kind-direct_message": "私信",
  "notifications.kind-label": "筛选：",
  "notifications.kind-new_ticket": "工单",
  "notifications.kind-post_like": "点赞",
  "notifications.kind-replies": "回复",
  "notifications.select": "选择",
  "notifications.select-all": "全选",
  "notifications.select-cancel": "取消",
  "notifications.selected-count": "已选 {count} 条",
  "notifications.tab-all": "全部",
  "notifications.tab-unread": "未读",
  "notifications.title": "通知",
  "own-likes.breadcrumb": "点赞",
  "own-likes.breadcrumb-profile": "个人",
  "own-likes.count": "共 {count} 条帖子",
  "own-likes.crumb": "点赞",
  "own-likes.empty": "你还没有给任何帖子点赞。",
  "own-likes.title": "我点过赞的帖子",
  "own-likes.untitled": "（无标题）",
  "own-ratings.breadcrumb": "评分",
  "own-ratings.breadcrumb-profile": "个人",
  "own-ratings.count": "共 {count} 个页面",
  "own-ratings.crumb": "评分",
  "own-ratings.empty": "你还没有给任何页面评分。",
  "own-ratings.title": "我评过分的页面",
  "own-tickets.breadcrumb": "工单",
  "own-tickets.breadcrumb-profile": "个人",
  "own-tickets.clear-all": "清空",
  "own-tickets.clear-selected": "清理所选",
  "own-tickets.confirm": "清理",
  "own-tickets.confirm-clear-all": "确定清空“我提交的工单”吗？清空后这些记录将不再在此显示，管理人员仍可查看。",
  "own-tickets.confirm-clear-selected": "确定清理所选的 {count} 项吗？清理后这些记录将不再在此显示，管理人员仍可查看。",
  "own-tickets.count": "共 {count} 份",
  "own-tickets.crumb": "工单",
  "own-tickets.detail-crumb": "工单详情",
  "own-tickets.empty": "您尚未提交过工单、入组申请或检举。",
  "own-tickets.field-body": "提交内容",
  "own-tickets.field-kind": "类型",
  "own-tickets.field-messages": "检举的消息",
  "own-tickets.field-page": "提交时所在页面",
  "own-tickets.field-reason": "检举理由",
  "own-tickets.field-reply": "处理回复",
  "own-tickets.field-reported": "被检举人",
  "own-tickets.field-reviewed": "处理时间",
  "own-tickets.field-site": "站点",
  "own-tickets.field-status": "状态",
  "own-tickets.field-submitted": "提交时间",
  "own-tickets.kind-membershipapply": "入组申请",
  "own-tickets.kind-report": "用户检举",
  "own-tickets.kind-ticket": "支持工单",
  "own-tickets.no-reply": "暂无回复。",
  "own-tickets.not-found": "该工单不存在，或您无权查看。",
  "own-tickets.select": "选择",
  "own-tickets.select-all": "全选",
  "own-tickets.select-cancel": "取消",
  "own-tickets.selected-count": "已选 {count} 项",
  "own-tickets.status-approved": "已通过",
  "own-tickets.status-closed": "已关闭",
  "own-tickets.status-dismissed": "已驳回",
  "own-tickets.status-pending": "待处理",
  "own-tickets.status-rejected": "已拒绝",
  "own-tickets.status-reviewed": "已处理",
  "own-tickets.title": "我提交的工单",
  "own-tickets.untitled": "（无标题）",
  "page-404.create-page": "创建页面",
  "page-404.not-found": "您请求的页面 {page} 不存在",
  "page-login-status.admin": "管理面板",
  "page-login-status.favourites": "收藏",
  "page-login-status.liked-posts": "点赞",
  "page-login-status.messages": "私信",
  "page-login-status.my-tickets": "工单",
  "page-login-status.notifications": "通知",
  "page-login-status.or": "或",
  "page-login-status.profile": "账户",
  "page-login-status.ratings": "评分",
  "page-login-status.settings": "设置",
  "page-login-status.sign-in": "登录",
  "page-login-status.sign-out": "登出",
  "page-login-status.sign-up": "创建账户",
  "page-login-status.signup-closed": "本站设置了不允许注册。",
  "page-options.authorship": "作者信息",
  "page-options.backlinks": "反向链接",
  "page-options.delete": "删除",
  "page-options.discuss": "讨论",
  "page-options.edit": "编辑",
  "page-options.edit-forbidden": "您没有编辑本页的权限。",
  "page-options.error-dismiss": "关闭",
  "page-options.error-label": "错误:",
  "page-options.favourite": "收藏",
  "page-options.files": "附件",
  "page-options.hint.authorship": "检视并调整本页记录的作者。",
  "page-options.hint.backlinks": "检视链接至本页或引用本页的页面。",
  "page-options.hint.delete": "删除本页，或将其移入归档分类。",
  "page-options.hint.discuss": "若您想要讨论本页内容，这是最简单的方法。",
  "page-options.hint.edit": "点击编辑本页内容。",
  "page-options.hint.favourite": "把本页加入你的收藏，或取消收藏。",
  "page-options.hint.files": "检视并管理本页附件。",
  "page-options.hint.history": "查看本页过去是如何沿革的。",
  "page-options.hint.lock": "锁定本页，使其只能由管理员编辑。",
  "page-options.hint.more": "展开其余的页面工具。",
  "page-options.hint.new-child": "以本页为父页面新建一个页面。",
  "page-options.hint.parent": "检视 / 设定父页面（用以建立浏览足迹与结构化配置）。",
  "page-options.hint.rate": "为本页评分，并查看已投出的票。",
  "page-options.hint.rename": "变更页面名称（及 URL 地址，或许会影响分类）。",
  "page-options.hint.source": "在不编辑的情形下检视维基源代码。",
  "page-options.hint.tags": "检视并修改本页的标签。",
  "page-options.history": "历史记录",
  "page-options.lock": "锁定页面",
  "page-options.more": "选项",
  "page-options.new-child": "创建子页面",
  "page-options.parent": "父页面",
  "page-options.rate": "评分",
  "page-options.rename": "重新命名",
  "page-options.saving": "保存中...",
  "page-options.source": "页面源代码",
  "page-options.tags": "标签",
  "page-options.watch-start": "开始关注",
  "page-options.watch-stop": "停止关注",
  "page.header.back-to-site": "返回站点",
  "page.navigation.edit-profile": "设置",
  "page.navigation.favourites": "收藏",
  "page.navigation.liked-posts": "点赞",
  "page.navigation.messages": "私信",
  "page.navigation.my-tickets": "工单",
  "page.navigation.notifications": "通知",
  "page.navigation.profile": "个人主页",
  "page.navigation.ratings": "评分",
  "page.profile-page.title": "用户界面",
  "search.author-placeholder": "作者",
  "search.category-placeholder": "分类",
  "search.comment-count": "{count} 条评论",
  "search.created": "创建 {when}",
  "search.days-ago": "{count}天前",
  "search.empty": "未找到匹配的文章。",
  "search.failed": "搜索失败，请稍后再试。",
  "search.hours-ago": "{count}小时前",
  "search.just-now": "刚刚",
  "search.load-more": "加载更多",
  "search.minutes-ago": "{count}分钟前",
  "search.months-ago": "{count}个月前",
  "search.placeholder": "搜索…",
  "search.tags-placeholder": "标签（空格分隔，- 排除）",
  "search.total": "共 {total} 条结果",
  "search.updated": "更新 {when}",
  "search.years-ago": "{count}年前",
  "user-actions.block": "拉黑",
  "user-actions.cancel": "取消",
  "user-actions.confirm": "确定",
  "user-actions.confirm-block": "拉黑该用户后，对方将无法向你发送私信。确定拉黑吗？",
  "user-actions.confirm-unblock": "确定要取消对该用户的拉黑吗？",
  "user-actions.failed": "操作失败",
  "user-actions.unblock": "取消拉黑",
  "util.date-format.day-1": "周一",
  "util.date-format.day-2": "周二",
  "util.date-format.day-3": "周三",
  "util.date-format.day-4": "周四",
  "util.date-format.day-5": "周五",
  "util.date-format.day-6": "周六",
  "util.date-format.day-7": "周天",
  "util.date-format.days": "{days}天",
  "util.date-format.hours": "{hours}小时",
  "util.date-format.minutes": "{minutes}分钟",
  "util.date-format.month-1": "1月",
  "util.date-format.month-10": "10月",
  "util.date-format.month-11": "11月",
  "util.date-format.month-12": "12月",
  "util.date-format.month-2": "2月",
  "util.date-format.month-3": "3月",
  "util.date-format.month-4": "4月",
  "util.date-format.month-5": "5月",
  "util.date-format.month-6": "6月",
  "util.date-format.month-7": "7月",
  "util.date-format.month-8": "8月",
  "util.date-format.month-9": "9月",
  "util.date-format.seconds": "{seconds}秒",
  "util.fetch-util.read-failed": "读取响应失败",
  "util.pagination.next": "下一页 »",
  "util.pagination.page-of-total": "第 {page} 页，共 {maxPages} 页",
  "util.pagination.previous": "« 上一页",
  "util.wikidot-message.author-label": "作者：",
  "util.wikidot-message.date-label": "创建日期：",
  "util.wikidot-message.dismiss": "关闭消息",
  "util.wikidot-message.page-label": "页面名称：",
  "util.wikidot-message.preview-note": "提示：这只是预览。",
  "util.wikidot-message.revision-label": "版本号：",
  "util.wikidot-message.to-editor": "向下到编辑器",
  "util.wikidot-message.to-revisions": "向下到版本列表",
  "util.wikidot-message.unsaved-note": "如果现在关闭此页面，更改将不会保存。",
  "util.wikidot-modal.confirm-cancel": "取消",
  "util.wikidot-modal.error-dismiss": "关闭",
  "util.wikidot-modal.error-label": "错误：",
  "util.wikidot-modal.revert-cancel": "取消",
  "util.wikidot-modal.revert-confirm": "您确定要回退到版本 {revision}吗？",
  "util.wikidot-modal.revert-confirm-button": "是，恢复",
  "util.wikidot-modal.revert-title": "恢复页面版本？"
}
